import { render, staticRenderFns } from "./cropManage.vue?vue&type=template&id=566bf0c4&"
import script from "./cropManage.vue?vue&type=script&lang=js&"
export * from "./cropManage.vue?vue&type=script&lang=js&"
import style0 from "./cropManage.vue?vue&type=style&index=0&id=566bf0c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports